import { q, qq } from "../../helper/q"
import { compareSlider } from "./slider"
import { send } from "./send"
import hermes from "hermes"

//  Удаление одного товара
export const delCompareInit = () => {
  const delButtons = qq(".compareSlideClose")

  delButtons.forEach((button, index) => {
    button.removeEventListener("click", () => {}, true)
    button.addEventListener("click", () => {
      //  посылаем запрос
      send(button.dataset.id, "delete").then(res => {
        //  оповещаем слущателей о количестве товара в сравнение
        hermes.send(
          "updateCompare",
          {
            count: res.result.items.length,
            action: "remove"
          },
          true
        )

        // Если слайд был последний, грузим пустую страницу
        if (res.result.items.length === 0) {
          getEmptyPage().then(page => {
            // Удаляем слайд
            compareSlider.removeSlide(index)
            q(".compareContainer").innerHTML = page
          })
        } else {
          // Удаляем слайд
          compareSlider.removeSlide(index)
        }

        // Пересчитываем номера
        Array.from(compareSlider.slides).forEach((slide, index) => {
          q(".compareSlideProductHeader span", slide).innerHTML = index + 1
        })
      })
    })
  })

  const cleanButtons = qq(".compareClearAll")
  cleanButtons.forEach(button => {
    button.addEventListener("click", () => {
      send("", "clean").then(res => {
        //  оповещаем слущателей о количестве товара в сравнение
        hermes.send(
          "updateCompare",
          {
            count: res.result.items.length,
            action: "remove"
          },
          true
        )

        // грузим пустую страницу
        getEmptyPage().then(page => {
          // Удаляем слайды
          compareSlider.removeAllSlides()
          q(".compareContainer").innerHTML = page
        })
      })
    })
  })
}

/**
 * This function load empty compare page
 *
 * @returns {Promise.<String>} A promeise return empty page
 */

const getEmptyPage = () => {
  return fetch("/catalog/compare/?ajax=yes", {
    method: "GET",
    credentials: "include"
  }).then(page => page.text())
}
